import { useEffect, useRef, useState } from "react";

import video1 from "../../../assets/video/01.mp4";
import video2 from "../../../assets/video/02.mp4";
import video3 from "../../../assets/video/03.mp4";

const videos = [video1, video2, video3];

const OfflineVideoPlayer = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef(null);

  const handleVideoEnd = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener("ended", handleVideoEnd);

      // Start the video manually as some browsers may not respect the autoPlay flag
      videoElement.play();
    }

    return () => {
      if (videoElement) videoElement.removeEventListener("ended", handleVideoEnd);
    };
  }, [currentVideoIndex]);

  return (
    <video
      ref={videoRef}
      src={videos[currentVideoIndex]}
      autoPlay
      muted // Add this if you want the video to be muted
      loop={false} // Set loop to false since we are manually handling looping
    >
      Your browser does not support the video tag.
    </video>
  );
};

export default OfflineVideoPlayer;
